// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.banner[data-v-c4ea5182] {\n  color: white;\n  align-content: center;\n  align-content: space-around;\n}\n.home[data-v-c4ea5182] {\n  background-size: cover;\n}\n.ourmembers[data-v-c4ea5182] {\n  background: #7D3DFF;\n}\n", ""]);
// Exports
module.exports = exports;
